  import { defineStore } from 'pinia';
  
  export const useSidebarStore = defineStore('sidebar', {
    state: () => ({
      isSidebarOpen: false
    }),
    actions: {
      toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
      },
      openSidebar() {
        this.isSidebarOpen = true;
      },
      closeSidebar() {
        this.isSidebarOpen = false;
      },
    },
  });
